import {
  AppDefinedVariables,
  Data,
  DittoVariable,
  NumStringVariable,
} from "../textInterfaces";

export function replaceNumStringVariables(
  data: Data,
  appDefinedVariables?: AppDefinedVariables,
): string {
  const keys = Object.keys(data.variables as Record<string, DittoVariable>);

  return keys.reduce((acc, key) => {
    const re = new RegExp(`{{${key}}}`, "g");

    let value;
    if (appDefinedVariables?.hasOwnProperty(key)) {
      if (typeof appDefinedVariables[key] === "object") {
        return "";
      }
      value = appDefinedVariables[key];
    } else {
      value = (data.variables as Record<string, NumStringVariable>)[key]
        .fallback;
    }

    if (typeof value === "undefined") {
      throw new Error(
        `Attempted to process text without any variable or fallbacks found for [key="${key}"]`,
      );
    }

    return acc.replace(re, String(value));
  }, data.text);
}
